import { render, staticRenderFns } from "./CertSave774.vue?vue&type=template&id=4f1662e2&scoped=true&"
import script from "./CertSave774.vue?vue&type=script&lang=js&"
export * from "./CertSave774.vue?vue&type=script&lang=js&"
import style0 from "./CertSave774.vue?vue&type=style&index=0&id=4f1662e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1662e2",
  null
  
)

export default component.exports